import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import ScrollToTop from '@/components/base/ScrollToTop';
import { categories } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = categories.find((c) => c.slug === slug);
  const categoryArticles = slug ? getArticlesByCategory(slug) : [];

  if (!currentCategory) {
    return (
      <>
        <ScrollToTop />
        <Navbar />
        <main className="pt-16 min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-2xl font-heading text-foreground-800 mb-3">分类不存在</h1>
            <Link to="/" className="text-primary-500 hover:text-primary-600">返回首页</Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: currentCategory.name },
  ];

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-50 border-b border-foreground-100/60">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <Breadcrumb items={breadcrumbItems} />
            <div className="py-8">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className={`${currentCategory.icon} text-primary-600 text-xl`}></i>
                </div>
                <div>
                  <h1 className="text-2xl md:text-3xl font-heading text-foreground-900">
                    {currentCategory.name}
                  </h1>
                  <p className="text-sm text-foreground-400 mt-0.5">
                    {currentCategory.description}
                  </p>
                </div>
              </div>
              <p className="text-xs text-foreground-400">
                共 {currentCategory.articleCount} 篇爆料 · 持续更新中
              </p>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex gap-2 py-4 overflow-x-auto flex-wrap">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-full text-sm whitespace-nowrap transition-colors ${
                  cat.slug === slug
                    ? 'bg-primary-500 text-white font-medium'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="py-6">
            {categoryArticles.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {categoryArticles.map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto rounded-full bg-background-100 flex items-center justify-center mb-4">
                  <i className="ri-inbox-line text-2xl text-foreground-300"></i>
                </div>
                <p className="text-foreground-500">该分类暂无爆料内容</p>
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}